// src/PageB.js (Example file structure)
import {Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import BrowserFullscreenToggle from './BrowserFullscreenToggle';
import './App.css';

const HomePage = () => {
  return (

    
    <Container>
      <Row>
        <nav style={{ marginBottom: '20px' }}>
            <BrowserFullscreenToggle />
            <Link to="/Animation_01"><button>BallBox</button></Link>
            <Link to="/Animation_02"><button>LineWaves</button></Link>
            <Link to="/Animation_03"><button>BlackHole</button></Link>
            <Link to="/Animation_04"><button>Fire</button></Link>
        </nav>
       
      </Row>
    </Container>
    
  );
};

export default HomePage;